import { Fragment } from "react";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeaderTwo from "../../component/layout/pageheader-2";
import Author from "../../component/sidebar/author";
import Comment from "../../component/sidebar/comment";
import CourseSideCetagory from "../../component/sidebar/course-cetagory";
import CourseSideDetail from "../../component/sidebar/course-detail";
import Respond from "../../component/sidebar/respond";
import Western from "../../component/layout/Sing/western";


const WesternSingSingle = () => {

    // -------- Tutors for Western Vocal Category --------
    const westernTutors = [
        {
            name: "Alex Morgan",
            expertise: "Pop & Western Contemporary",
            experience: "6 Years Experience",
        },
        {
            name: "Sophia Williams",
            expertise: "Voice Control, Resonance, Tone Training",
            experience: "4 Years Experience",
        },
        {
            name: "David Miller",
            expertise: "Rock & Jazz Vocal Trainer",
            experience: "8 Years Experience",
        },
    ];

    return (
        <Fragment>
            <Header />
            <Western title="Western Vocal Training" />

            <div className="course-single-section padding-tb section-bg" style={{ backgroundColor: "#F0F8FF" }}>
                <div className="container">
                    <div className="row justify-content-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-8">
                            <div className="main-part">

                                {/* Course Overview */}
                                <div className="course-item">
                                    <h3>Western Vocal Course Overview</h3>
                                    <p>Improve pitch, tone, resonance, chest/head voice control, and expand your vocal range with Western vocal techniques.</p>
                                </div>

                                {/* ---------- Course Video Section ---------- */}
                                <div className="course-video" style={{ marginTop: "40px" }}>
                                    <div className="course-video-title">
                                        <h4>Course Content</h4>
                                    </div>

                                    <div className="course-video-content">
                                        <div className="accordion" id="WesternSingAcc">
                                            <div className="accordion-item">
                                                <div className="accordion-header" id="ws01">
                                                    <button className="d-flex justify-content-between" data-bs-toggle="collapse" data-bs-target="#videolist1" aria-expanded="true" aria-controls="videolist1">
                                                        <span>1. Vocal Fundamentals</span>
                                                        <span>5 Lessons</span>
                                                    </button>
                                                </div>

                                                <div id="videolist1" className="accordion-collapse collapse show" aria-labelledby="ws01" data-bs-parent="#WesternSingAcc">
                                                    <ul className="lab-ul video-item-list">
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.1 Welcome & Course Introduction – 03:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.2 Breath Control Techniques – 04:20 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.3 Pitch & Tone Exercises – 05:15 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.4 Resonance & Head Voice – 06:10 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.5 Daily Vocal Practice Routine – 07:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ---------- End Course Video Section ---------- */}

                                {/* ---------- Tutors Section ---------- */}
                                <div style={{ marginTop: "40px", padding: "20px", background: "#FFFFFF", borderRadius: "10px" }}>
                                    <h3 style={{ marginBottom: "20px" }}>Western Vocal Tutors</h3>

                                    {westernTutors.map((tutor, index) => (
                                        <div key={index} style={{ padding: "15px", borderBottom: "1px solid #ddd" }}>
                                            <h5 style={{ margin: 0 }}>{tutor.name}</h5>
                                            <p style={{ margin: "5px 0" }}>{tutor.expertise}</p>
                                            <small style={{ color: "#666" }}>{tutor.experience}</small>
                                        </div>
                                    ))}
                                </div>
                                {/* ---------- End Tutors Section ---------- */}

                                {/* Default Components */}
                                <Author />
                                <Comment />
                                <Respond />
                            </div>
                        </div>

                        {/* RIGHT SIDEBAR */}
                        <div className="col-lg-4">
                            <div className="sidebar-part">
                                <CourseSideDetail />
                                <CourseSideCetagory />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default WesternSingSingle;
